import { render, staticRenderFns } from "./ListContact.vue?vue&type=template&id=268cb97b&scoped=true&lang=html&"
import script from "./ListContact.vue?vue&type=script&lang=js&"
export * from "./ListContact.vue?vue&type=script&lang=js&"
import style0 from "./ListContact.vue?vue&type=style&index=0&id=268cb97b&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268cb97b",
  null
  
)

export default component.exports